import { render, staticRenderFns } from "./interest-invoices-created-dialog.vue?vue&type=template&id=ff5af8f6"
import script from "./interest-invoices-created-dialog.vue?vue&type=script&lang=js"
export * from "./interest-invoices-created-dialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports